var RealTimeQuoteType={
    Delayed : 1,
    Dde : 2,
    Nasdaq :3
}
export default RealTimeQuoteType;
